import { render, staticRenderFns } from "./ListMotoristaView.vue?vue&type=template&id=fb03b98a&scoped=true&"
import script from "./ListMotoristaView.vue?vue&type=script&lang=ts&"
export * from "./ListMotoristaView.vue?vue&type=script&lang=ts&"
import style0 from "./ListMotoristaView.vue?vue&type=style&index=0&id=fb03b98a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb03b98a",
  null
  
)

export default component.exports